import React, {useEffect, useState} from "react";
import localization from "assets/localization/localization";
import {Button} from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
// import '../main.css'
import Layout from 'components/sales/layout/layout';
import CustomModal from "../../../valetServices/modal";
import DivLayout from "../../../../components/sales/divLayout/divLayout";
import DatePicker from "../../../../components/sales/datePicker/datePicker";
import {BaseUrl} from "../../../../contexts/baseUrl/baseUrl";
import {toast} from "react-toastify";

const IncreaseCreditLimit = ({
                                 increaseCreditLimit,
                                 addCreditLimit = [],
                                 userById,
                                 userDetailsById=[],
                                 match,
                                 history
                             }) => {

    var today = new Date();
    today.setDate(today.getDate() + 1);

    const [isLoading, setIsLoading] = useState(false);
    const [count, setCount] = useState(0)
    const [inputList, setInputList] = useState(
        [{till_date: '', increased_limit: '', user_id:''}]
    );
    const [limitAmount, setLimitAmount] = useState(0)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await userById(match?.params?.user_id)
            setIsLoading(false)
        })()

    }, [])

    const handleInputValue = (val, key) => {
        const list = [...inputList];
        list[0][key] = val;
        setInputList([...list]);
    };

    const handleOnSubmitForm = async () => {
        let inputValues = inputList[0]
        inputValues['user_id'] = userDetailsById?.id

        if(inputValues['increased_limit'] <= 0 || inputValues['increased_limit'] === ""){
            toast.error("Increase limit can't be 0 or empty")
            return false
        }

        let limit = inputValues['increased_limit'].toString().split('.');
        if(limit[0] !== undefined && limit[0].length > 7){
            toast.error("Increase limit can't be greater than 10,00,000")
            return false
        }

        if(inputValues['till_date'] === ""){
            toast.error("Till date is missing")
            return false
        }
        setIsLoading(true)
        await increaseCreditLimit(inputValues)
        setIsLoading(false)
        setCount(count + 1)
    }

    return (
        <>
            <Layout isGoback isLoading={isLoading}>
                <div className="container-fluid">
                    <div className="card">
                        {addCreditLimit !== null && parseInt(addCreditLimit?.status_code) !== 200 &&
                            <CustomModal
                                msg={addCreditLimit?.message}
                                click={count}/>
                        }
                        {addCreditLimit !== null && parseInt(addCreditLimit?.status_code) === 200 &&
                            <CustomModal
                                msg={addCreditLimit?.message}
                                isPageLoad={true}
                                click={count}
                                history={history}/>
                        }
                        <div className="card-header">
                            {localization.creditLimit}
                        </div>
                        <div className="card-body">
                            <div className="row col-md-12">
                                <div className="details-listing">
                                    <DivLayout
                                        heading={localization.currentAmount}
                                        data={userDetailsById?.wallet_balance}
                                    />
                                    <DivLayout
                                        heading={localization.holdAmount}
                                        data={userDetailsById?.hold_amt}
                                    />
                                    <DivLayout
                                        heading={localization.owedAmount}
                                        data={userDetailsById?.owed_amt}
                                    />
                                </div>


                                <div className="col-md-6 col-sm-12">
                                    <ConstantInput
                                        label={localization.increaseCreditLimit}
                                        type="text"
                                        value={inputList.increased_limit}
                                        handleChange={(val) => {
                                            handleInputValue(parseFloat(val), 'increased_limit');
                                            setLimitAmount(val === "" ? 0 : val)
                                        }}
                                        required
                                        isStarRequired={true}
                                    />
                                </div>
                                <div className="col-md-6 col-sm-12">
                                    <DatePicker
                                        handleChange={(val) =>
                                            handleInputValue(val, 'till_date')
                                        }
                                        label={localization.tillDate}
                                        required={true}
                                        minimumDate={today}
                                        value={""}
                                    />
                                </div>
                                <div className="details-listing">
                                <div className="col-md-6 col-sm-12">
                                    <DivLayout
                                        heading={localization.totalLimit}
                                        data={(userDetailsById?.wallet_balance !== null && userDetailsById?.wallet_balance !== "") ? parseFloat(userDetailsById?.wallet_balance)+parseFloat(limitAmount) : parseFloat(limitAmount)}
                                    />
                                </div>
                                </div>
                                <div className="col-md-12">
                                    <center><Button onClick={handleOnSubmitForm}>
                                        {localization.submitDtl}
                                    </Button>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default IncreaseCreditLimit
